import axios from "axios"
if (localStorage.getItem("userAuthEnseignant")) {
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthEnseignant"))
  var token = userAuthScolarite.user.api_token
}
export default axios.create({
  withCredentials: true,
  baseURL: `https://ismsf.scolarite.backcresus-institut.ovh/api/`,
  headers: {
    Authorization: `Bearer ${token}`,
    apipassword: "3KbmGc5tZhuDbPtb",
    'X-Frame-Options' : "DENY"
  },
})
